import { render, staticRenderFns } from "./EvidenceFusion.vue?vue&type=template&id=18f23542&scoped=true"
import script from "./EvidenceFusion.vue?vue&type=script&lang=js"
export * from "./EvidenceFusion.vue?vue&type=script&lang=js"
import style0 from "./EvidenceFusion.vue?vue&type=style&index=0&id=18f23542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f23542",
  null
  
)

export default component.exports